import React from 'react';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
//import InboxIcon from '@mui/icons-material/MoveToInbox';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupsIcon from '@mui/icons-material/Groups';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import MessageIcon from '@mui/icons-material/Message';
import DvrIcon from '@mui/icons-material/Dvr';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import LogoutIcon from '@mui/icons-material/Logout';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
//import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import { Link } from 'react-router-dom';
//import Toolbar from '@material-ui/core/Toolbar';
//import Typography from '@material-ui/core/Typography';
//import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/IconButton';
//import MenuIcon from '@material-ui/icons/Menu';
//import MenuItem from '@material-ui/core/MenuItem';
//import MenuList from '@material-ui/core/MenuList';
//import Menu from '@material-ui/core/Menu';
//import Fab from '@material-ui/core/Fab';
//import AddIcon from '@material-ui/icons/Add';
//import AccountCircle from '@material-ui/icons/AccountCircle';
import * as actions from "../store/actions";
import CreditsBadge from './CreditsBadge';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    toolbarButtons: {
        marginLeft: 'auto',
    }
}));

const drawerWidth = 240;

function TieIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M352 128C352 198.7 294.7 256 224 256C153.3 256 96 198.7 96 128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128zM209.1 359.2L176 304H272L238.9 359.2L272.2 483.1L311.7 321.9C388.9 333.9 448 400.7 448 481.3C448 498.2 434.2 512 417.3 512H30.72C13.75 512 0 498.2 0 481.3C0 400.7 59.09 333.9 136.3 321.9L175.8 483.1L209.1 359.2z"/>
            </svg>
        </SvgIcon>
    );
}

function UsersIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path d="M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 33.71-12.78 64.21-33.16 88h199.7C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192z"/>
            </svg>
        </SvgIcon>
    )
}


function ButtonAppBar(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorNavEl, setNavAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const openNav = Boolean(anchorNavEl);
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleNavMenu = (event) => {
        console.log('inside nav menu');
        setNavAnchorEl(event.currentTarget);
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleNavClose = () => {
        setNavAnchorEl(null);
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    let navigationItems = null;
    let fabLink = null;
    let accountType = null;
    //onClick={handleDrawerToggle}
    if (props.isAuthenticated && props.role==='dealer'){
        fabLink = "/addclient";
        accountType = "Dealer";
        navigationItems = (

            <List>
                <ListItem button onClick={() => setMobileOpen(false)} key="Dashboard" component={Link} to="/">
                    <ListItemIcon>
                        <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Add_Client" component={Link} to="/addclient">
                    <ListItemIcon>
                        <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Add Client" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Clients" component={Link} to="/clients">
                    <ListItemIcon>
                        <GroupsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Clients" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Transactions" component={Link} to="/transactions">
                    <ListItemIcon>
                        <ReceiptLongIcon />
                    </ListItemIcon>
                    <ListItemText primary="Transactions" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Check_MAC" component={Link} to="/checkmac">
                    <ListItemIcon>
                        <ScreenSearchDesktopIcon />
                    </ListItemIcon>
                    <ListItemText primary="Check MAC" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Message" component={Link} to="/dmessage">
                    <ListItemIcon>
                        <MessageIcon />
                    </ListItemIcon>
                    <ListItemText primary="Message" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Support" component={Link} to="/dsupport">
                    <ListItemIcon>
                        <ContactSupportIcon />
                    </ListItemIcon>
                    <ListItemText primary="Support" />
                </ListItem>
            </List>
        )
    }

    if (props.isAuthenticated && props.role==='reseller'){
        fabLink = "/adddealer";
        accountType = "Reseller";
        navigationItems = (
            <List>
                <ListItem button onClick={() => setMobileOpen(false)} key="Dashboard" component={Link} to="/">
                    <ListItemIcon>
                        <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Add Dealer" component={Link} to="/adddealer">
                    <ListItemIcon>
                        <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Add Dealer" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Dealers" component={Link} to="/dealers">
                    <ListItemIcon>
                        <SupervisorAccountIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dealers" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Reseller_Clients" component={Link} to="/resellerclients">
                    <ListItemIcon>
                        <GroupsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Users" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Transactions" component={Link} to="/transactions">
                    <ListItemIcon>
                        <ReceiptLongIcon />
                    </ListItemIcon>
                    <ListItemText primary="Transactions" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Check_MAC" component={Link} to="/checkmac">
                    <ListItemIcon>
                        <ScreenSearchDesktopIcon />
                    </ListItemIcon>
                    <ListItemText primary="Check MAC" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Message" component={Link} to="/rmessage">
                    <ListItemIcon>
                        <MessageIcon />
                    </ListItemIcon>
                    <ListItemText primary="Message" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Support" component={Link} to="/rsupport">
                    <ListItemIcon>
                        <ContactSupportIcon />
                    </ListItemIcon>
                    <ListItemText primary="Support" />
                </ListItem>
            </List>
        )
    }

    if (props.isAuthenticated && props.role==='superreseller'){
        fabLink = "/addreseller";
        accountType = "Super Reseller";
        navigationItems = (
            <List>
                <ListItem button onClick={() => setMobileOpen(false)} key="Dashboard" component={Link} to="/">
                    <ListItemIcon>
                        <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Add Reseller" component={Link} to="/addreseller">
                    <ListItemIcon>
                        <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Add Reseller" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Resellers" component={Link} to="/resellers">
                    <ListItemIcon>
                        <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Resellers" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Manager_Dealers" component={Link} to="/managerdealers">
                    <ListItemIcon>
                        <SupervisorAccountIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dealers" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Manager_Clients" component={Link} to="/managerclients">
                    <ListItemIcon>
                        <GroupsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Users" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Transactions" component={Link} to="/transactions">
                    <ListItemIcon>
                        <ReceiptLongIcon />
                    </ListItemIcon>
                    <ListItemText primary="Transactions" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Check_MAC" component={Link} to="/checkmac">
                    <ListItemIcon>
                        <ScreenSearchDesktopIcon />
                    </ListItemIcon>
                    <ListItemText primary="Check MAC" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Message" component={Link} to="/smessage">
                    <ListItemIcon>
                        <MessageIcon />
                    </ListItemIcon>
                    <ListItemText primary="Message" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Support" component={Link} to="/ssupport">
                    <ListItemIcon>
                        <ContactSupportIcon />
                    </ListItemIcon>
                    <ListItemText primary="Support" />
                </ListItem>
            </List>
        )
    }

    if (props.isAuthenticated && props.role==='admin'){
        fabLink = "/addsuperreseller";
        accountType = "Admin";
        navigationItems = (
            <List>
                <ListItem button onClick={() => setMobileOpen(false)} key="Dashboard" component={Link} to="/">
                    <ListItemIcon>
                        <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Add Super Reseller" component={Link} to="/addsuperreseller">
                    <ListItemIcon>
                        <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText primary="Add Super Reseller" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Super_Resellers" component={Link} to="/superresellers">
                    <ListItemIcon>
                        <TieIcon />
                    </ListItemIcon>
                    <ListItemText primary="Super Resellers" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Admin_Resellers" component={Link} to="/manageresellers">
                    <ListItemIcon>
                        <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Resellers" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Admin_Dealers" component={Link} to="/managedealers">
                    <ListItemIcon>
                        <SupervisorAccountIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dealers" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Admin_Clients" component={Link} to="/manageclients">
                    <ListItemIcon>
                        <GroupsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Users" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Transactions" component={Link} to="/transactions">
                    <ListItemIcon>
                        <ReceiptLongIcon />
                    </ListItemIcon>
                    <ListItemText primary="Transactions" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="PanelMessage" component={Link} to="/message">
                    <ListItemIcon>
                        <DvrIcon />
                    </ListItemIcon>
                    <ListItemText primary="Panel Message" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Message" component={Link} to="/amessage">
                    <ListItemIcon>
                        <MessageIcon />
                    </ListItemIcon>
                    <ListItemText primary="Message Clients" />
                </ListItem>
                <ListItem button onClick={() => setMobileOpen(false)} key="Support" component={Link} to="/asupport">
                    <ListItemIcon>
                        <Badge color="secondary" badgeContent={props.total_active_tickets}>
                            <ContactSupportIcon />
                        </Badge>
                    </ListItemIcon>
                    <ListItemText primary="Manage Tickets" />
                </ListItem>
            </List>
        )
    }

    const logoutItemText = "Logout [" + props.name + "]";

    const drawer = (
        <div>
            <Toolbar />
            <Divider />
            {navigationItems}
            <Divider />
            <List>
                <ListItem button key="logout" component={Link} to="/logout">
                    <ListItemIcon>
                        <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText primary={logoutItemText} />
                </ListItem>
            </List>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    //<div className={classes.root}>
    //    <AppBar position="static">
    //        <Toolbar>
    //            <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleNavMenu}>
    //                <MenuIcon />
    //            </IconButton>
    //            <Menu
    //                id="menu-appbar"
    //                anchorEl={anchorNavEl}
    //                anchorOrigin={{
    //                    vertical: 'top',
    //                    horizontal: 'left',
    //                }}
    //                keepMounted
    //                transformOrigin={{
    //                    vertical: 'top',
    //                    horizontal: 'left',
    //                }}
    //                open={openNav}
    //                onClose={handleNavClose}
    //            >
    //                {navigationItems}
    //            </Menu>
    //            <Typography variant="h6" className={classes.title}>
    //                {accountType} Panel
    //            </Typography>
    //            <Fab aria-label="add" className={classes.fabButton} component={Link} to={fabLink} >
    //                <AddIcon />
    //            </Fab>
    //            {props.role !=='admin' && <CreditsBadge />}
    //            <div>
    //                <IconButton
    //                    aria-label="account of current user"
    //                    aria-controls="menu-appbar"
    //                    aria-haspopup="true"
    //                    onClick={handleMenu}
    //                    color="inherit"
    //                >
    //                    <AccountCircle />
    //                </IconButton>
    //                <Menu
    //                    id="menu-appbar"
    //                    anchorEl={anchorEl}
    //                    anchorOrigin={{
    //                        vertical: 'top',
    //                        horizontal: 'right',
    //                    }}
    //                    keepMounted
    //                   transformOrigin={{
    //                        vertical: 'top',
    //                        horizontal: 'right',
    //                    }}
    //                    open={open}
    //                    onClose={handleClose}
    //                >
    //                    <MenuItem onClick={handleClose} component={Link} to="/logout">Logout {props.name}</MenuItem>
    //                </Menu>
    //            </div>
    //        </Toolbar>
    //    </AppBar>
    //</div>
//container={container}
    //sx={{
    //    width: { sm: `calc(100% - ${drawerWidth}px)` },
    //    ml: { sm: `${drawerWidth}px` },
    //}}
//<Box display='flex' flexGrow={1}>
    //, display: { sm: 'none' }
    //<CssBaseline />
    return (
        <>

            <AppBar
                position="fixed"
                sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}
            >
                <Toolbar>

                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { md: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        {accountType} Panel
                    </Typography>


                    <div className={classes.toolbarButtons}>
                        {props.role !=='admin' && <CreditsBadge />}
                    </div>
                </Toolbar>

            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer

                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'block', md: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'none', md: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
        </>
    );
}

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        name: state.auth.name,
        isAuthenticated: state.auth.token !== null,
        role: state.auth.role,
        total_active_tickets: state.countActiveTickets.total
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetClientList: (token, page, search) => dispatch(actions.clientList(token, page, search)),
        onSearchClients: (search) => dispatch(actions.searchClients(search))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonAppBar);